/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_All_LabelInputs */



/**
* | output |
* | --- |
* | "Accept all corrections" |
*
* @param {Spellcheck_Accept_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_all_label = /** @type {((inputs?: Spellcheck_Accept_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accepter toutes les corrections")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Korrekturen akzeptieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accetta tutte le correzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принять все исправления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aceptar todas las correcciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("接受所有更正。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべての修正を受け入れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी सुधार स्वीकार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aceitar todas as correções")
	return /** @type {LocalizedString} */ ("Accept all corrections")
});